import Job from './Job';
import TimeRegistration from './TimeRegistration';

export default class TimeRegistrationContainer {
  allowedMinutes: number | null = null;
  registeredMinutes: number | null = null;
  minutesPerUnit: number | null = null;
  registrations: Array<TimeRegistration> = [];
  jobs: Array<Job> = [];
}